import { createAction } from 'redux-act';
// apply Separation action
const applySeparationRequest = createAction('APPLY_SEPARATION_REQUEST', data => data);
const applySeparationSuccess = createAction('APPLY_SEPARATION_SUCCESS', data => data);
const applySeparationError = createAction('APPLY_SEPARATION_ERROR');

// Update Separation action
const updateSeparationRequest = createAction('UPDATE_SEPARATION_REQUEST', data => data);
const updateSeparationSuccess = createAction('UPDATE_SEPARATION_SUCCESS', data => data);
const updateSeparationError = createAction('UPDATE_SEPARATION_ERROR');

// get Separation action
const getSeparationRequest = createAction('GET_SEPARATION_REQUEST', data => data);
const getSeparationSuccess = createAction('GET_SEPARATION_SUCCESS', data => data);
const getSeparationError = createAction('GET_SEPARATION_ERROR');

// Get Separation Approval action
const getSeparationApprovalRequest = createAction('GET_SEPARATION_APPROVAL_REQUEST', data => data);
const getSeparationApprovalSuccess = createAction('GET_SEPARATION_APPROVAL_SUCCESS', data => data);
const getSeparationApprovalError = createAction('GET_SEPARATION_APPROVAL_ERROR');

// Approve Reject Separation action
const approveRejectSeparationRequest = createAction('APPROVE_REJECT_SEPARATION_REQUEST', data => data);
const approveRejectSeparationSuccess = createAction('APPROVE_REJECT_SEPARATION_SUCCESS', data => data);
const approveRejectSeparationError = createAction('APPROVE_REJECT_SEPARATION_ERROR');

// Get Clearance Question action
const getClearanceQuestionRequest = createAction('GET_CLEARANCE_QUESTION_REQUEST', data => data);
const getClearanceQuestionSuccess = createAction('GET_CLEARANCE_QUESTION_SUCCESS', data => data);
const getClearanceQuestionError = createAction('GET_CLEARANCE_QUESTION_ERROR');

// Apply Clearance Form action
const applyClearanceFormRequest = createAction('APPLY_CLEARANCE_FORM_REQUEST', data => data);
const applyClearanceFormSuccess = createAction('APPLY_CLEARANCE_FORM_SUCCESS', data => data);
const applyClearanceFormError = createAction('APPLY_CLEARANCE_FORM_ERROR');

// Show Designation action
const separationDetailsRequest = createAction('SEPARATION_REQUEST', data => data);
const separationDetailsSuccess = createAction('SEPARATION_SUCCESS', data => data);
const separationDetailsError = createAction('SEPARATION_ERROR');

// Show Designation action
const getClearanceRequest = createAction('GET_CLEARANCE_REQUEST', data => data);
const getClearanceSuccess = createAction('GET_CLEARANCE_SUCCESS', data => data);
const getClearanceError = createAction('GET_CLEARANCE_ERROR');

// clear existing Separation action
const handleClearSeparationStore = createAction('HANDLE_CLEAR_SEPARATION_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    applySeparationRequest,
    applySeparationSuccess,
    applySeparationError,

    updateSeparationRequest,
    updateSeparationSuccess,
    updateSeparationError,

    getSeparationRequest,
    getSeparationSuccess,
    getSeparationError,

    getSeparationApprovalRequest,
    getSeparationApprovalSuccess,
    getSeparationApprovalError,

    approveRejectSeparationRequest,
    approveRejectSeparationSuccess,
    approveRejectSeparationError,

    getClearanceQuestionRequest,
    getClearanceQuestionSuccess,
    getClearanceQuestionError,

    applyClearanceFormRequest,
    applyClearanceFormSuccess,
    applyClearanceFormError,

    separationDetailsRequest,
    separationDetailsSuccess,
    separationDetailsError,

    getClearanceRequest,
    getClearanceSuccess,
    getClearanceError,

    handleClearSeparationStore,
    // toastMsgAction,
    
}